import angular from 'angular';
import SelfServiceOutOfStockWidgetComponent from './self-service-out-of-stock-widget-component';

export default angular
  .module('self-service-out-of-stock-widget', [])
  .component('selfServiceOutOfStockWidget', new SelfServiceOutOfStockWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/self-service-out-of-stock/self-service-out-of-stock-widget-module.js